import React from "react";
import Style from "./FlashingDots.module.css";

const FlashingDots = () => {
  return <div className={Style.dot_flashing} />;
};

export default FlashingDots;
